// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"ArticleBreadcrumbs_breadcrumbs__iwLXX","breadcrumb":"ArticleBreadcrumbs_breadcrumb__7m706","breadcrumb_link":"ArticleBreadcrumbs_breadcrumb_link__qAjuu"};